import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initializeMsal } from './auth/msalInstance';
import { reportClientError } from './api/clientErrors';
import { missingConfigKeys } from './config';
import { installErrorReporting } from './observability/errorReporting';
import { applyStoredTheme } from './theme/ThemeProvider';
import './i18n';

// Order matters: Bootstrap first, then the icon font, then the application's own overrides.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'primeicons/primeicons.css';
import './index.css';

// Before the first render, so a failure while the application is starting is reported too.
installErrorReporting({ report: (report) => void reportClientError(report) });

// Also before the first render: the stylesheet follows the browser's preference on its own, and this is what
// applies a choice made here on top of it.
applyStoredTheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('The #root element is missing from index.html.');
}

const root = createRoot(container);

function render() {
  root.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}

// MSAL must be initialised (and the login redirect consumed) before the first render, otherwise the
// authentication response is dropped. A misconfigured deployment skips it and lets App() explain why.
if (missingConfigKeys().length > 0) {
  render();
} else {
  initializeMsal()
    .catch((error) => console.error('MSAL initialisation failed', error))
    .finally(render);
}
